export default class Background {
    constructor(game, width, height, y, speedModifier, image) {
        this.game = game
        this.width = width
        this.height = height
        this.speedModifier = speedModifier
        this.image = document.getElementById(image)
        this.x = 0
        this.y = y
    }
    update(deltaTime) {
        if(this.x < -this.width) {
            let lastDifference = this.x + this.width

            this.x = lastDifference - (this.game.gameSpeed * deltaTime * this.speedModifier)
        } else {
            this.x -= this.game.gameSpeed * deltaTime * this.speedModifier
        }
    }
    draw(context) {
        context.globalAlpha = 1
        context.drawImage(this.image, this.x, this.y, this.width, this.height)
        context.drawImage(this.image, this.x + this.width, this.y, this.width, this.height)
    }

    changeImage(image) {
        this.image = document.getElementById(image)
    }
}